import { v4 as uuid } from "uuid";
export const warehouseSelectList = [
  {
    id: uuid(),
    title: "Warehouse",
    value: "name",
  },
];
